/** 区块类型 → 图标。组件栏、区块面板、斜杠菜单里的块都用这一份，认得快。 */
import {
  AlignLeftOutlined,
  AppstoreOutlined,
  EditOutlined,
  FileTextOutlined,
  FontSizeOutlined,
  LayoutOutlined,
  MinusOutlined,
  PictureOutlined,
  QrcodeOutlined,
  TableOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';
import type { ContractSectionType } from '../../contract/types';

export const SECTION_ICONS: Record<ContractSectionType, ReactNode> = {
  header: <FontSizeOutlined />,
  info_grid: <AppstoreOutlined />,
  detail_table: <TableOutlined />,
  free_table: <TableOutlined />,
  text_block: <AlignLeftOutlined />,
  signature: <EditOutlined />,
  attachment: <PictureOutlined />,
  code: <QrcodeOutlined />,
  rich_text: <FileTextOutlined />,
  divider: <MinusOutlined />,
  columns: <LayoutOutlined />,
};
